const state = {
    datasets: null,
    skinStories: null,
    collaborators: null,
    allSkinStories: null,
    skinStoriesTags: null
};

const actions = {
    saveDatasets({ commit }, datasets) {
        commit('save2Datasets',datasets);
    },
    saveSkinStories({ commit }, skinStories) {
        commit('save2SkinStories', skinStories);
    },
    saveAllSkinStories({ commit }, allSkinStories) {
        commit('save2AllSkinStories', allSkinStories);
    },
    saveCollaborators({ commit }, collaborators) {
        commit('save2Collaborators',collaborators);
    },
    saveSkinStoriesTags({ commit }, skinStoriesTags) {
        commit('save2SkinStoriesTags', skinStoriesTags);
    }
}

const mutations = {
    save2Datasets(state, payload) {
        console.log("saved datasets");
        state.datasets = payload;
    },
    save2SkinStories(state, payload) {
        console.log("saved skinstories");
        state.skinStories = payload;
    },
    save2AllSkinStories(state, payload) {
        console.log("saved all skinstories");
        state.allSkinStories = payload;
    },
    save2Collaborators(state, payload) {
        console.log("saved collaborators");
        state.collaborators = payload;
    },
    save2SkinStoriesTags(state, payload) {
        console.log("saved skinstories tags");
        state.skinStoriesTags = payload;
    }
}


export const global = {
    namespaced: true,
    state,
    actions,
    mutations,
};